export default __webpack_public_path__ + "457f85c.png";